// useMapRankings — TanStack Query wrapper for the map-popup composite
// score + per-category neighbor counts.
//
// Plan 08-04 (gap closure for ROADMAP § Phase 08 SC #4):
//   - queryKey = ['map-rankings', radiusMiles]
//     Different cache slot from useRankings (keyed by full FilterState)
//     because the map ignores sort/county/recency — only radius matters
//     for the popup composite + neighbor count.
//   - staleTime = 30_000 — matches useRankings + useMapData stale window.
//   - AbortController-cancellable via the queryFn signal.
//
// The dashboard and the map popup both compute "amenities in radius" at
// the same radius. Both go through web/lib/ranking.js server-side — no
// client-side double-counting risk.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchMapRankings } from '@/lib/api';
import type { RankedPropertyDTO } from '@/types/db';

export function useMapRankings(
  radiusMiles: number,
): UseQueryResult<RankedPropertyDTO[], Error> {
  return useQuery<RankedPropertyDTO[], Error>({
    queryKey: ['map-rankings', radiusMiles],
    queryFn: ({ signal }) => fetchMapRankings(radiusMiles, signal),
    staleTime: 30_000,
  });
}
